import { gql } from '@apollo/client';

/* ── the signed-in account ───────────────────────────────────── */

/**
 * The session's own user. Takes no arguments: the resolver reads the bearer
 * token, so this answers for whoever is signed in and for nobody else.
 */
export const GET_PROFILE = gql`
  query GetProfile {
    getProfile {
      id
      name
      email
      phoneNumber
      emailVerified
      mfaEnabled
      profilePictureUrl
      languagePreference
    }
  }
`;

/**
 * The signed-in account's own row, for the fields `getProfile` does not expose.
 *
 * Only the residency ids are wanted, and only because `updateProfile` nulls
 * them when they are absent from its input (`user.py:257-265` has an `else:
 * = None` on both) — so a write that changes a phone number has to send them
 * back unchanged. `getAllUsers(ids:)` is the only query that carries them, and
 * it answers for the caller's own id as readily as for anyone's.
 */
export const MY_ACCOUNT_RESIDENCY = gql`
  query MyAccountResidency($ids: [Int!]) {
    getAllUsers(ids: $ids) {
      items {
        id
        primaryResidencyId
        investmentOptimizedResidencyId
      }
    }
  }
`;
